export default __webpack_public_path__ + "static/media/title_zh_cn_sp.3b94ee02.png";